import React, { Component } from "react";
import FacturaAdministracion from "../administracion/FacturaAdministracion";
import Header from "../../components/Header";
import Slider from "../../components/slider";

class CrearFacturaAdmin extends Component{

    render(){
        return(
            <div id="factura">
            <Header
            buzon="Buzon"
            facturas="Facturación"
            proyectos="Proyectos"
            pedidos="Pedidos"
            visible="true"
            visibleBU="true"
          />
          <Slider
            title="Administración"
            size="slider-small"
            visibleAdmin="true"
          />
          <FacturaAdministracion/>
          </div>
        );
    }
}

export default CrearFacturaAdmin;